import { createSelector } from '@reduxjs/toolkit';

import {
  AUTHENTICATED_USER_ACCESS,
  VIDEO_INVITE_PEOPLE_ACTION,
  VIDEO_PASSWORD_PROTECT_ACTION,
  VIDEO_SHARE_PRIVATE_ACTION,
  VIDEO_SHARE_WITH_TEAM_ACTION,
} from 'constants/scopes';

export const selectUserScopes = (state: {
  user?: { current?: { scopes?: string[] } };
}): string[] => {
  if (state?.user?.current?.scopes) {
    return state.user.current.scopes;
  }

  return [];
};

const selectScopeName = (_state, scopeName) => scopeName;

export const hasScope: (userScopes, scopeName) => boolean = createSelector(
  [selectUserScopes, selectScopeName],
  (userScopes, scopeName) => {
    if (scopeName) {
      return userScopes.includes(scopeName);
    }

    return false;
  }
);

const selectScopeNames = (_state, scopeNames) => scopeNames;

export const hasSomeScopes = createSelector(
  [selectUserScopes, selectScopeNames],
  (userScopes, scopeNames) => {
    if (scopeNames.length > 0) {
      return scopeNames.some(scope => userScopes.includes(scope));
    }

    return false;
  }
);

export const selectHasSharingScope = createSelector(selectUserScopes, scopes =>
  [
    scopes.includes(VIDEO_INVITE_PEOPLE_ACTION),
    scopes.includes(VIDEO_PASSWORD_PROTECT_ACTION),
    scopes.includes(VIDEO_SHARE_PRIVATE_ACTION),
    scopes.includes(VIDEO_SHARE_WITH_TEAM_ACTION),
  ].some(scope => scope)
);

export const selectHasAuthenticatedAccessScope = createSelector(
  selectUserScopes,
  scopes => scopes.includes(AUTHENTICATED_USER_ACCESS)
);
